<template>
  <form
    id="signup"
    @submit="login"
    action="#"
    method="post"
    novalidate="true"
    v-if="!mfa"
  >
    <h1>{{ $t("onboard.loginForm.header") }}</h1>
    <div class="error msg">{{ errMessage }}</div>
    <div v-if="deAuth" class="warning msg">
      <p>{{ $t("onboard.loginForm.text") }}</p>
    </div>

    <label class="required" for="email">{{
      $t("onboard.loginForm.email")
    }}</label>
    <input
      id="email"
      v-if="foundEmail"
      readonly="readonly"
      v-bind:class="{ error: errForm || errEmail }"
      name="email"
      v-model="email"
      v-on:input="
        errEmail = false;
        clearError();
      "
    />
    <input
      id="email"
      v-else
      v-bind:class="{ error: errForm || errEmail }"
      name="email"
      v-model="email"
      v-on:input="
        errEmail = false;
        clearError();
      "
    />
    <p class="error" v-if="errEmail">{{ $t("onboard.loginForm.noEmail") }}</p>

    <label class="required" for="pass">{{
      $t("onboard.loginForm.password")
    }}</label>
    <router-link class="recovery" to="/recovery">{{
      $t("onboard.loginForm.link.forgotPw")
    }}</router-link>
    <input
      type="password"
      id="pass"
      v-bind:class="{ error: errForm || errPw }"
      name="pass"
      v-model="password"
      v-on:input="
        errPw = false;
        clearError();
      "
    />
    <p class="error" v-if="errPw">{{ $t("onboard.loginForm.noPassword") }}</p>

    <input
      type="submit"
      class="submit"
      v-bind:value="$t('onboard.loginForm.button.login')"
    />

    <SelectLang />
  </form>
  <MFAInput v-else />
</template>

<script>
import SelectLang from "@/components/onboard/SelectLanguage.vue";
import { defaultLanguage, language } from "@/utils/language";
import { userService } from "@/services/user.service";
import { validFileInclusion } from "@/utils/validFileInclusion";
import MFAInput from "@/components/onboard/MFAInput.vue";

export default {
  name: "LoginForm",
  props: ["foundEmail"],
  components: { MFAInput, SelectLang },
  data: function() {
    return {
      invalidForm: true,
      errMessage: null,
      errEmail: null,
      errPw: null,
      email: null,
      password: null,
      deAuth: localStorage.getItem("deauth"),
      invite: false,
      errForm: false,
      mfa: false,
    };
  },
  created: function() {
    const { err } = this.$route.query;
    if (err) {
      this.errMessage = this.$t("onboard.loginForm.mfaExpiredErrorMsg");
      this.$router.replace({ path: this.$route.path });
      localStorage.removeItem("mfaExpired", true);
    }
    if (localStorage.getItem("mfaExpired")) {
      const mfaExpired = localStorage.getItem("mfaExpired");
      const now = Date.now();
      if (now < parseInt(mfaExpired, 10)) {
        this.setMfa(true);
      } else {
        localStorage.removeItem("mfaExpired", true);
      }
    }
    if (this.foundEmail) {
      this.email = this.foundEmail;
    }

    localStorage.removeItem("deauth", true);
    if (
      localStorage.getItem("wsInvite") ||
      localStorage.getItem("planInvite")
    ) {
      this.invite = true;
    }
  },
  methods: {
    login: function(event) {
      this.invalidForm = false;
      this.errMessage = null;
      this.errEmail = null;
      this.errPw = null;

      if (!this.email || validFileInclusion(this.email)) {
        this.invalidForm = true;
        this.errEmail = true;
      }
      if (!this.password || validFileInclusion(this.password)) {
        this.invalidForm = true;
        this.errPw = true;
      }

      if (!this.invalidForm) {
        userService
          .login(this.email, this.password)
          .then((user) => {
            let languageCode = user.userInfo.languageCode;
            if (!language().some((x) => x.value === languageCode)) {
              languageCode = defaultLanguage();
            }
            this.$i18n.locale = languageCode;
            localStorage.setItem("lang", languageCode);
            if (user.mfa === true) {
              this.setMfa(true);
            } else {
              if (this.$route.query.dest) {
                this.$router.push(this.$route.query.dest);
              } else {
                this.$router.push("plans");
              }
            }
          })
          .catch(() => {
            this.errMessage = this.$t("onboard.loginForm.errorMsg");
            this.errForm = true;
          });
      }

      event.preventDefault();
    },
    setMfa: function(mfa) {
      this.mfa = mfa;
    },
    clearError: function() {
      this.errForm = false;
      this.errMessage = null;
      this.invalidForm = false;
    },
  },
};
</script>
<style scoped type="scss">
.error {
  margin-bottom: 20px;
}
p {
  margin-top: -25px;
}
</style>
